var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFlagYemen(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1354_16920)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16 32.2705C24.8366 32.2705 32 25.1071 32 16.2705C32 7.43395 24.8366 0.270508 16 0.270508C7.16344 0.270508 0 7.43395 0 16.2705C0 25.1071 7.16344 32.2705 16 32.2705Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 32.2708C22.8794 32.2708 28.7441 27.9288 31.0048 21.8359H0.995178C3.25587 27.9288 9.12055 32.2708 16 32.2708Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16 0.270508C9.12055 0.270508 3.25587 4.61251 0.995178 10.7053H31.0049C28.7441 4.61251 22.8794 0.270508 16 0.270508Z",
    fill: "#D80027"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1354_16920"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.270508)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagYemen);
export default __webpack_public_path__ + "static/media/flag_yemen.227590c7492dc042b18ef56027db4118.svg";
export { ForwardRef as ReactComponent };